import { inject as Ta, ref as c, computed as i, watch as G } from "vue";
import { dateArray as fe, yearArray as ce, pluckValueFromRange as Y, quarterArray as ve, monthArray as me, getDefaultTime as K, strictParse as U } from "./ghl-ui.es964.js";
import { usePanelCommonProps as wa, usePanelCommon as Fa } from "./ghl-ui.es1536.js";
import { datePickerInjectionKey as Oa } from "./ghl-ui.es966.js";
import { MONTH_ITEM_HEIGHT as ye, START_YEAR as he } from "./ghl-ui.es1319.js";
import l from "./ghl-ui.es978.js";
import m from "./ghl-ui.es1326.js";
import A from "./ghl-ui.es976.js";
import P from "./ghl-ui.es1322.js";
import v from "./ghl-ui.es1330.js";
import f from "./ghl-ui.es1321.js";
import y from "./ghl-ui.es1126.js";
import q from "./ghl-ui.es977.js";
import F from "./ghl-ui.es1329.js";
import De from "./ghl-ui.es1518.js";
import Ma from "./ghl-ui.es1125.js";
import Ea from "./ghl-ui.es1517.js";
const Ka = Object.assign(Object.assign({}, wa), {
  defaultCalendarStartTime: Number,
  defaultCalendarEndTime: Number,
  bindCalendarMonths: Boolean,
  actions: {
    type: Array,
    default: () => ["clear", "confirm"]
  }
});
function Ja(n, R) {
  var z, H;
  const {
    isDateDisabledRef: J,
    isStartHourDisabledRef: Ae,
    isEndHourDisabledRef: Re,
    isStartMinuteDisabledRef: Ce,
    isEndMinuteDisabledRef: Se,
    isStartSecondDisabledRef: ge,
    isEndSecondDisabledRef: Ve,
    isStartDateInvalidRef: be,
    isEndDateInvalidRef: Te,
    isStartTimeInvalidRef: we,
    isEndTimeInvalidRef: Fe,
    isStartValueInvalidRef: Oe,
    isEndValueInvalidRef: Me,
    isRangeInvalidRef: X,
    localeRef: g,
    rangesRef: Z,
    closeOnSelectRef: Ee,
    updateValueOnCloseRef: Pe,
    firstDayOfWeekRef: $,
    datePickerSlots: Ie,
    monthFormatRef: p,
    yearFormatRef: ee,
    quarterFormatRef: ae
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  } = Ta(Oa), Ye = {
    isDateDisabled: J,
    isStartHourDisabled: Ae,
    isEndHourDisabled: Re,
    isStartMinuteDisabled: Ce,
    isEndMinuteDisabled: Se,
    isStartSecondDisabled: ge,
    isEndSecondDisabled: Ve,
    isStartDateInvalid: be,
    isEndDateInvalid: Te,
    isStartTimeInvalid: we,
    isEndTimeInvalid: Fe,
    isStartValueInvalid: Oe,
    isEndValueInvalid: Me,
    isRangeInvalid: X
  }, r = Fa(n), ke = c(null), xe = c(null), te = c(null), ne = c(null), k = c(null), x = c(null), N = c(null), Q = c(null), {
    value: C
  } = n, re = (z = n.defaultCalendarStartTime) !== null && z !== void 0 ? z : Array.isArray(C) && typeof C[0] == "number" ? C[0] : Date.now(), o = c(re), s = c((H = n.defaultCalendarEndTime) !== null && H !== void 0 ? H : Array.isArray(C) && typeof C[1] == "number" ? C[1] : l(m(re, 1)));
  h(!0);
  const V = c(Date.now()), b = c(!1), I = c(0), S = i(() => n.dateFormat || g.value.dateFormat), O = c(Array.isArray(C) ? A(C[0], S.value, r.dateFnsOptions.value) : ""), M = c(Array.isArray(C) ? A(C[1], S.value, r.dateFnsOptions.value) : ""), _e = i(() => b.value ? "end" : "start"), le = i(() => {
    var e;
    return fe(o.value, n.value, V.value, (e = $.value) !== null && e !== void 0 ? e : g.value.firstDayOfWeek);
  }), je = i(() => {
    var e;
    return fe(s.value, n.value, V.value, (e = $.value) !== null && e !== void 0 ? e : g.value.firstDayOfWeek);
  }), Ue = i(() => le.value.slice(0, 7).map((e) => {
    const {
      ts: a
    } = e;
    return A(a, g.value.dayFormat, r.dateFnsOptions.value);
  })), qe = i(() => A(o.value, g.value.monthFormat, r.dateFnsOptions.value)), ze = i(() => A(s.value, g.value.monthFormat, r.dateFnsOptions.value)), He = i(() => A(o.value, g.value.yearFormat, r.dateFnsOptions.value)), Ne = i(() => A(s.value, g.value.yearFormat, r.dateFnsOptions.value)), Qe = i(() => {
    const {
      value: e
    } = n;
    return Array.isArray(e) ? e[0] : null;
  }), We = i(() => {
    const {
      value: e
    } = n;
    return Array.isArray(e) ? e[1] : null;
  }), Be = i(() => {
    const {
      shortcuts: e
    } = n;
    return e || Z.value;
  }), Le = i(() => ce(Y(n.value, "start"), V.value, {
    yearFormat: ee.value
  })), Ge = i(() => ce(Y(n.value, "end"), V.value, {
    yearFormat: ee.value
  })), Ke = i(() => {
    const e = Y(n.value, "start");
    return ve(e ?? Date.now(), e, V.value, {
      quarterFormat: ae.value
    });
  }), Je = i(() => {
    const e = Y(n.value, "end");
    return ve(e ?? Date.now(), e, V.value, {
      quarterFormat: ae.value
    });
  }), Xe = i(() => {
    const e = Y(n.value, "start");
    return me(e ?? Date.now(), e, V.value, {
      monthFormat: p.value
    });
  }), Ze = i(() => {
    const e = Y(n.value, "end");
    return me(e ?? Date.now(), e, V.value, {
      monthFormat: p.value
    });
  });
  G(i(() => n.value), (e) => {
    if (e !== null && Array.isArray(e)) {
      const [a, t] = e;
      O.value = A(a, S.value, r.dateFnsOptions.value), M.value = A(t, S.value, r.dateFnsOptions.value), b.value || sa(e);
    } else
      O.value = "", M.value = "";
  });
  function ue(e, a) {
    (R === "daterange" || R === "datetimerange") && (v(e) !== v(a) || f(e) !== f(a)) && r.disableTransitionOneTick();
  }
  G(o, ue), G(s, ue);
  function h(e) {
    const a = P(o.value), t = P(s.value);
    (n.bindCalendarMonths || a >= t) && (e ? s.value = l(m(a, 1)) : o.value = l(m(t, -1)));
  }
  function $e() {
    o.value = l(m(o.value, 12)), h(!0);
  }
  function pe() {
    o.value = l(m(o.value, -12)), h(!0);
  }
  function ea() {
    o.value = l(m(o.value, 1)), h(!0);
  }
  function aa() {
    o.value = l(m(o.value, -1)), h(!0);
  }
  function ta() {
    s.value = l(m(s.value, 12)), h(!1);
  }
  function na() {
    s.value = l(m(s.value, -12)), h(!1);
  }
  function ra() {
    s.value = l(m(s.value, 1)), h(!1);
  }
  function la() {
    s.value = l(m(s.value, -1)), h(!1);
  }
  function ua(e) {
    o.value = e, h(!0);
  }
  function ia(e) {
    s.value = e, h(!1);
  }
  function ie(e) {
    const a = J.value;
    if (!a)
      return !1;
    if (!Array.isArray(n.value) || _e.value === "start")
      return a(e, "start", null);
    {
      const {
        value: t
      } = I;
      return e < I.value ? a(e, "start", [t, t]) : a(e, "end", [t, t]);
    }
  }
  function sa(e) {
    if (e === null)
      return;
    const [a, t] = e;
    o.value = a, P(t) <= P(a) ? s.value = l(P(m(a, 1))) : s.value = l(P(t));
  }
  function oa(e) {
    if (!b.value)
      b.value = !0, I.value = e.ts, E(e.ts, e.ts, "done");
    else {
      b.value = !1;
      const {
        value: a
      } = n;
      n.panel && Array.isArray(a) ? E(a[0], a[1], "done") : Ee.value && R === "daterange" && (Pe.value ? se() : W());
    }
  }
  function da(e) {
    if (b.value) {
      if (ie(e.ts))
        return;
      e.ts >= I.value ? E(I.value, e.ts, "wipPreview") : E(e.ts, I.value, "wipPreview");
    }
  }
  function W() {
    X.value || (r.doConfirm(), se());
  }
  function se() {
    b.value = !1, n.active && r.doClose();
  }
  function _(e) {
    typeof e != "number" && (e = l(e)), n.value === null ? r.doUpdateValue([e, e], n.panel) : Array.isArray(n.value) && r.doUpdateValue([e, Math.max(n.value[1], e)], n.panel);
  }
  function j(e) {
    typeof e != "number" && (e = l(e)), n.value === null ? r.doUpdateValue([e, e], n.panel) : Array.isArray(n.value) && r.doUpdateValue([Math.min(n.value[0], e), e], n.panel);
  }
  function E(e, a, t) {
    if (typeof e != "number" && (e = l(e)), t !== "shortcutPreview") {
      let d, w;
      if (R === "datetimerange") {
        const {
          defaultTime: u
        } = n;
        Array.isArray(u) ? (d = K(u[0]), w = K(u[1])) : (d = K(u), w = d);
      }
      d && (e = l(y(e, d))), w && (a = l(y(a, w)));
    }
    r.doUpdateValue([e, a], n.panel && t === "done");
  }
  function D(e) {
    return R === "datetimerange" ? l(Ma(e)) : R === "monthrange" ? l(P(e)) : l(Ea(e));
  }
  function fa(e) {
    const a = U(e, S.value, /* @__PURE__ */ new Date(), r.dateFnsOptions.value);
    if (q(a))
      if (n.value) {
        if (Array.isArray(n.value)) {
          const t = y(n.value[0], {
            year: v(a),
            month: f(a),
            date: F(a)
          });
          _(D(l(t)));
        }
      } else {
        const t = y(/* @__PURE__ */ new Date(), {
          year: v(a),
          month: f(a),
          date: F(a)
        });
        _(D(l(t)));
      }
    else
      O.value = e;
  }
  function ca(e) {
    const a = U(e, S.value, /* @__PURE__ */ new Date(), r.dateFnsOptions.value);
    if (q(a)) {
      if (n.value === null) {
        const t = y(/* @__PURE__ */ new Date(), {
          year: v(a),
          month: f(a),
          date: F(a)
        });
        j(D(l(t)));
      } else if (Array.isArray(n.value)) {
        const t = y(n.value[1], {
          year: v(a),
          month: f(a),
          date: F(a)
        });
        j(D(l(t)));
      }
    } else
      M.value = e;
  }
  function va() {
    const e = U(O.value, S.value, /* @__PURE__ */ new Date(), r.dateFnsOptions.value), {
      value: a
    } = n;
    if (q(e)) {
      if (a === null) {
        const t = y(/* @__PURE__ */ new Date(), {
          year: v(e),
          month: f(e),
          date: F(e)
        });
        _(D(l(t)));
      } else if (Array.isArray(a)) {
        const t = y(a[0], {
          year: v(e),
          month: f(e),
          date: F(e)
        });
        _(D(l(t)));
      }
    } else
      oe();
  }
  function ma() {
    const e = U(M.value, S.value, /* @__PURE__ */ new Date(), r.dateFnsOptions.value), {
      value: a
    } = n;
    if (q(e)) {
      if (a === null) {
        const t = y(/* @__PURE__ */ new Date(), {
          year: v(e),
          month: f(e),
          date: F(e)
        });
        j(D(l(t)));
      } else if (Array.isArray(a)) {
        const t = y(a[1], {
          year: v(e),
          month: f(e),
          date: F(e)
        });
        j(D(l(t)));
      }
    } else
      oe();
  }
  function oe(e) {
    const {
      value: a
    } = n;
    if (a === null || !Array.isArray(a)) {
      O.value = "", M.value = "";
      return;
    }
    e === void 0 && (e = a), O.value = A(e[0], S.value, r.dateFnsOptions.value), M.value = A(e[1], S.value, r.dateFnsOptions.value);
  }
  function ya(e) {
    e !== null && _(e);
  }
  function ha(e) {
    e !== null && j(e);
  }
  function Da(e) {
    r.cachePendingValue();
    const a = r.getShortcutValue(e);
    Array.isArray(a) && E(a[0], a[1], "shortcutPreview");
  }
  function Aa(e) {
    const a = r.getShortcutValue(e);
    Array.isArray(a) && (E(a[0], a[1], "done"), r.clearPendingValue(), W());
  }
  function T(e, a) {
    const t = e === void 0 ? n.value : e;
    if (e === void 0 || a === "start") {
      if (N.value) {
        const d = Array.isArray(t) ? f(t[0]) : f(Date.now());
        N.value.scrollTo({
          debounce: !1,
          index: d,
          elSize: ye
        });
      }
      if (k.value) {
        const d = (Array.isArray(t) ? v(t[0]) : v(Date.now())) - he;
        k.value.scrollTo({
          index: d,
          debounce: !1
        });
      }
    }
    if (e === void 0 || a === "end") {
      if (Q.value) {
        const d = Array.isArray(t) ? f(t[1]) : f(Date.now());
        Q.value.scrollTo({
          debounce: !1,
          index: d,
          elSize: ye
        });
      }
      if (x.value) {
        const d = (Array.isArray(t) ? v(t[1]) : v(Date.now())) - he;
        x.value.scrollTo({
          index: d,
          debounce: !1
        });
      }
    }
  }
  function Ra(e, a) {
    const {
      value: t
    } = n, d = !Array.isArray(t), w = e.type === "year" && R !== "yearrange" ? d ? y(e.ts, {
      month: f(R === "quarterrange" ? De(/* @__PURE__ */ new Date()) : /* @__PURE__ */ new Date())
    }).valueOf() : y(e.ts, {
      month: f(R === "quarterrange" ? De(t[a === "start" ? 0 : 1]) : t[a === "start" ? 0 : 1])
    }).valueOf() : e.ts;
    if (d) {
      const de = D(w), L = [de, de];
      r.doUpdateValue(L, n.panel), T(L, "start"), T(L, "end"), r.disableTransitionOneTick();
      return;
    }
    const u = [t[0], t[1]];
    let B = !1;
    switch (a === "start" ? (u[0] = D(w), u[0] > u[1] && (u[1] = u[0], B = !0)) : (u[1] = D(w), u[0] > u[1] && (u[0] = u[1], B = !0)), r.doUpdateValue(u, n.panel), R) {
      case "monthrange":
      case "quarterrange":
        r.disableTransitionOneTick(), B ? (T(u, "start"), T(u, "end")) : T(u, a);
        break;
      case "yearrange":
        r.disableTransitionOneTick(), T(u, "start"), T(u, "end");
    }
  }
  function Ca() {
    var e;
    (e = te.value) === null || e === void 0 || e.sync();
  }
  function Sa() {
    var e;
    (e = ne.value) === null || e === void 0 || e.sync();
  }
  function ga(e) {
    var a, t;
    return e === "start" ? ((a = k.value) === null || a === void 0 ? void 0 : a.listElRef) || null : ((t = x.value) === null || t === void 0 ? void 0 : t.listElRef) || null;
  }
  function Va(e) {
    var a, t;
    return e === "start" ? ((a = k.value) === null || a === void 0 ? void 0 : a.itemsElRef) || null : ((t = x.value) === null || t === void 0 ? void 0 : t.itemsElRef) || null;
  }
  const ba = {
    startYearVlRef: k,
    endYearVlRef: x,
    startMonthScrollbarRef: N,
    endMonthScrollbarRef: Q,
    startYearScrollbarRef: te,
    endYearScrollbarRef: ne
  };
  return Object.assign(Object.assign(Object.assign(Object.assign({
    startDatesElRef: ke,
    endDatesElRef: xe,
    handleDateClick: oa,
    handleColItemClick: Ra,
    handleDateMouseEnter: da,
    handleConfirmClick: W,
    startCalendarPrevYear: pe,
    startCalendarPrevMonth: aa,
    startCalendarNextYear: $e,
    startCalendarNextMonth: ea,
    endCalendarPrevYear: na,
    endCalendarPrevMonth: la,
    endCalendarNextMonth: ra,
    endCalendarNextYear: ta,
    mergedIsDateDisabled: ie,
    changeStartEndTime: E,
    ranges: Z,
    startCalendarMonth: qe,
    startCalendarYear: He,
    endCalendarMonth: ze,
    endCalendarYear: Ne,
    weekdays: Ue,
    startDateArray: le,
    endDateArray: je,
    startYearArray: Le,
    startMonthArray: Xe,
    startQuarterArray: Ke,
    endYearArray: Ge,
    endMonthArray: Ze,
    endQuarterArray: Je,
    isSelecting: b,
    handleRangeShortcutMouseenter: Da,
    handleRangeShortcutClick: Aa
  }, r), Ye), ba), {
    // datetimerangeonly
    startDateDisplayString: O,
    endDateInput: M,
    timePickerSize: r.timePickerSize,
    startTimeValue: Qe,
    endTimeValue: We,
    datePickerSlots: Ie,
    shortcuts: Be,
    startCalendarDateTime: o,
    endCalendarDateTime: s,
    justifyColumnsScrollState: T,
    handleFocusDetectorFocus: r.handleFocusDetectorFocus,
    handleStartTimePickerChange: ya,
    handleEndTimePickerChange: ha,
    handleStartDateInput: fa,
    handleStartDateInputBlur: va,
    handleEndDateInput: ca,
    handleEndDateInputBlur: ma,
    handleStartYearVlScroll: Ca,
    handleEndYearVlScroll: Sa,
    virtualListContainer: ga,
    virtualListContent: Va,
    onUpdateStartCalendarValue: ua,
    onUpdateEndCalendarValue: ia
  });
}
export {
  Ja as useDualCalendar,
  Ka as useDualCalendarProps
};
